if (customElements.get('before-after-card') === undefined) {
  class beforeAfterCard extends HTMLElement {
    constructor() {
      super()

      this.expandableQuote = this.querySelector('[data-expandable-quote]')
      this.quote = this.expandableQuote.querySelector('p')
      this.button = this.expandableQuote.querySelector('button')
      this.three_line_height =
        parseFloat(
          window
            .getComputedStyle(document.querySelector('before-after-card [data-expandable-quote] p.line-clamp-3'))
            .lineHeight.replace('px', '')
        ) * 3

      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            this.checkQuoteOverflow()
          }
        }
      })

      this.init()
    }

    toggleSeeMoreLess = () => {
      if (this.quote === undefined || this.button === undefined) return
      this.quote.classList.toggle('line-clamp-3')
      this.button.textContent = this.quote.classList.contains('line-clamp-3') ? 'See more' : 'See less'
    }

    checkQuoteOverflow = () => {
      if (this.quote === undefined || this.button === undefined) return
      if (!this.quote.classList.contains('line-clamp-3') && this.quote.offsetHeight <= this.three_line_height)
        return this.button.classList.add('hidden')
      if (this.quote.classList.contains('line-clamp-3') && this.quote.clientHeight >= this.quote.scrollHeight)
        return this.button.classList.add('hidden')
      this.button.classList.remove('hidden')
    }

    init() {
      this.button.addEventListener('click', () => this.toggleSeeMoreLess())
      this.checkQuoteOverflow()
      this.resizeObserver.observe(this.quote)
    }
  }

  customElements.define('before-after-card', beforeAfterCard)
}
